module.exports = __webpack_public_path__ + "img/Falabella.6c731d37.png";